import { render, staticRenderFns } from "./MailReminderFormFields.vue?vue&type=template&id=48a50eeb&"
import script from "./MailReminderFormFields.vue?vue&type=script&lang=js&"
export * from "./MailReminderFormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports